import { Component, Input, OnChanges } from '@angular/core';

import {
  BibliographicResource,
  OnlineResource,
} from '®shared/bibliographic-resource';
import { Permissions, UserPermissions } from '®shared/permissions';

@Component({
  selector: 'rl-resource',
  templateUrl: './resource.component.html',
})
export class ResourceComponent implements OnChanges {
  @Input() bibliographicResource: BibliographicResource;
  @Input() currentUserPermissions: UserPermissions;
  @Input() resourceEditUrl: string;
  @Input() resourceExportUrl: string;
  @Input() resourceImage: string;
  @Input() onlineResource: OnlineResource;

  canEditResource = false;

  ngOnChanges() {
    if (this.currentUserPermissions) {
      this.canEditResource = this.currentUserPermissions.hasPermission(
        Permissions.EDIT_LIST,
      );
    }
  }
}
